import { useState } from "react";

function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: "対応可能な開発範囲はどこまでですか？",
      answer:
        "Webサイト制作、Webアプリケーション開発、モバイルアプリ開発（iOS/Android）、システム開発、API開発など幅広く対応可能です。要件定義から設計、実装、テスト、運用保守まで一貫してサポートいたします。",
    },
    {
      question: "納期の目安を教えてください",
      answer:
        "プロジェクトの規模により異なりますが、小規模なWebサイトで1〜2ヶ月、中規模のWebアプリケーションで2〜4ヶ月、大規模システムで4〜6ヶ月程度が目安です。お急ぎの場合はご相談ください。",
    },
    {
      question: "保守契約の内容について教えてください",
      answer:
        "定期的なセキュリティ更新、バグ修正、パフォーマンス監視、バックアップ管理、技術サポートなどを含みます。月次または週次でレポートを提出し、改善提案も行います。プランにより対応範囲が異なります。",
    },
    {
      question: "支払い方法はどのようなものがありますか？",
      answer:
        "銀行振込のみ対応しています。プロジェクトの規模に応じて、着手金・中間金・完了金の分割払いも可能です。保守契約は月額または年額での契約となります。",
    },
    {
      question: "遠方でも対応可能ですか？",
      answer:
        "はい、全国どこでも対応可能です。オンラインミーティング（Zoom、Google Meetなど）を活用し、遠隔でも密なコミュニケーションを取りながらプロジェクトを進めます。必要に応じて訪問も可能です。",
    },
    {
      question: "レスポンシブ対応やSEO対策は含まれますか？",
      answer:
        "はい、標準で含まれます。スマートフォン、タブレット、PCなど全デバイスに最適化したレスポンシブデザインを実装します。また、基本的なSEO対策（メタタグ設定、構造化データ、サイトマップ生成など）も標準で行います。",
    },
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section
      id="faq"
      className="relative overflow-hidden bg-white px-6 py-16 md:px-12 md:py-24 lg:px-24"
    >
      <div className="relative mx-auto max-w-4xl" style={{ zIndex: 1 }}>
        <div className="fade-in-section mb-12 text-center md:mb-20">
          <h2 className="mb-3 text-4xl font-semibold text-gray-900 md:mb-4 md:text-6xl">
            <span className="text-red-500">F</span>AQ
          </h2>
          <p className="text-gray-600">よくある質問</p>
        </div>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="fade-in-section overflow-hidden rounded-lg border-2 border-gray-200 bg-white shadow-sm transition-all duration-300"
              style={{ transitionDelay: `${index * 30}ms` }}
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="flex w-full cursor-pointer items-center justify-between px-6 py-5 text-left transition-colors duration-200 hover:bg-gray-50 md:px-8 md:py-6"
              >
                <span className="pr-4 text-base font-medium text-gray-900 md:text-lg">
                  {faq.question}
                </span>
                <i
                  className={`flex-shrink-0 text-2xl text-red-500 transition-transform duration-300 ${
                    openIndex === index ? "ri-subtract-line" : "ri-add-line"
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? "max-h-96" : "max-h-0"
                }`}
              >
                <div className="px-8 pb-6 leading-relaxed text-gray-600">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default FAQ;
